import { Spinner, VStack } from "@chakra-ui/react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ZILLOUT_WEB_BASE_URL } from "../config/urls";
import { appendTrackingParams } from "../hooks/useTrackingSource";

const getCustomerAppBaseUrl = () => {
  if (window.location.hostname === "localhost") {
    return `${window.location.protocol}//${window.location.hostname}:3001`;
  }

  return ZILLOUT_WEB_BASE_URL;
};

const CustomerAppRedirect = () => {
  const location = useLocation();

  useEffect(() => {
    const targetUrl = appendTrackingParams(
      `${getCustomerAppBaseUrl()}${location.pathname}${location.search}`
    );

    window.location.replace(targetUrl);
  }, [location.pathname, location.search]);

  return (
    <VStack minH="100vh" justify="center" bg="#111111">
      <Spinner color="white" />
    </VStack>
  );
};

export default CustomerAppRedirect;
